/* eslint-disable no-console */
import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import Skeleton from '@material-ui/lab/Skeleton'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import DashboardIcon from '@material-ui/icons/Dashboard'
import ForumIcon from '@material-ui/icons/Forum'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'

import { sendMessage } from '../../utils/iframeUtil'

const StyledSearchBar = styled.div`
  width: 450px;
`

const typeToIcon = (type) => {
  switch (type) {
    case 'topic':
      return <ForumIcon />
    case 'dashboard':
      return <DashboardIcon />
    default:
      return <></>
  }
}

const SearchBar = () => {
  const [inputValue, setInputValue] = React.useState('')
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => {
    if (inputValue.length > 0) {
      setOpen(true)
    }
  }

  const handleInputChange = (event, newInputValue) => {
    // TODO: if the new input is within the filter list -> RUN
    setInputValue(newInputValue)
    if (newInputValue.length > 0) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }

  const handleSelectionChange = (event, newSelectedValue, reason) => {
    if (reason === 'select-option') {
      if (newSelectedValue.type === 'dashboard')
        sendMessage({ type: 'gotoDashboard', data: newSelectedValue.id })
      else if (newSelectedValue.type === 'topic')
        sendMessage({ type: 'gotoAnalysisBySearch', data: newSelectedValue.topicInfo })
    }
  }

  const renderOption = (option) => (
    <>
      <ListItemIcon>{typeToIcon(option.type)}</ListItemIcon>
      <span>{option.title}</span>
    </>
  )
  const filterOptions = createFilterOptions({
    limit: 5
  })

  const { searchableItems } = useSelector(({ accessibleDashboards, accessibleTopics }) => {
    if (!accessibleDashboards.accessibleDashboards || !accessibleTopics.accessibleTopics) {
      return {
        searchableItems: []
      }
    }

    return {
      searchableItems: accessibleTopics.accessibleTopics
        .concat(accessibleDashboards.accessibleDashboards)
        .map((item) => {
          return {
            id: item.topicId || item.dashboardId,
            type: item.topicId ? 'topic' : 'dashboard',
            title: `${item.name}  (${item.owner.name})`,
            topicInfo: item.topicId ? item : null // TODO: should we copy it instead?
          }
        })
    }
  }, shallowEqual)
  // eslint-disable-next-line no-console
  return (
    <StyledSearchBar>
      {searchableItems.length !== 0 ? (
        <Autocomplete
          fullWidth
          autoComplete
          autoHighlight
          limitTags={3}
          freeSolo
          open={open}
          onOpen={handleOpen}
          onClose={() => setOpen(false)}
          onChange={handleSelectionChange}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          // eslint-disable-next-line no-use-before-define
          filterOptions={filterOptions}
          options={searchableItems}
          getOptionLabel={(option) => option.title}
          renderOption={renderOption}
          renderInput={(params) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <TextField
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...params}
              label="Enter a topic or dashboard name"
              margin="normal"
              variant="outlined"
            />
          )}
        />
      ) : (
        <Skeleton height={48} />
      )}
    </StyledSearchBar>
  )
}

export default SearchBar
